<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<h1>Profile for {{ this.$store.state.user.username }}</h1>
			<v-form>
				<v-text-field
					v-model="firstname"
					label="First name"
					:readonly="!this.editable"
					required
					:variant="this.editable ? 'solo' : 'plain'"
				></v-text-field>
				<v-text-field
					v-model="lastname"
					label="Last name"
					:readonly="!this.editable"
					required
					:variant="this.editable ? 'solo' : 'plain'"
				></v-text-field>
				<v-text-field
					v-model="email"
					label="E-Mail"
					:readonly="!this.editable"
					required
					:variant="this.editable ? 'solo' : 'plain'"
				></v-text-field>
				<AirportInput
					@baseAirport="updateBaseAirport"
					:defaultValue="this.base"
					:editable="this.editable"
				/>
				<v-file-input
					clearable
					:disabled="!this.editable"
					v-on:change="updateFile($event)"
					label="Medical"
					name="medical"
				></v-file-input>

				<v-btn v-if="!this.editable" @click="edit()">Edit</v-btn>
				<v-btn
					color="green"
					v-if="this.editable"
					@click="save(this.$store.state.user._id)"
					>Save</v-btn
				>
				<v-btn color="red" v-if="this.editable" @click="reset()">Cancel</v-btn>
			</v-form>
		</v-main>
	</v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import AirportInput from "@/components/AirportInput";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

const FilePond = vueFilePond(
	FilePondPluginFileValidateSize,
	FilePondPluginImagePreview
);

export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	components: {
		NavBar,
		AirportInput,
		FilePond,
	},
	data() {
		return {
			editable: false,
			firstname: this.$store.state.user.firstname,
			lastname: this.$store.state.user.lastname,
			email: this.$store.state.user.email,
			base: {
				value: this.$store.state.user.baseAirport._id,
				label: this.$store.state.user.baseAirport.airport_codename,
			},
			medical: null,
		};
	},
	methods: {
		...mapMutations(["setUser"]),
		updateBaseAirport(val) {
			console.log("Updating base..");
			this.base.value = val.value;
			this.base.label = val.label;
			console.log("Base set to " + val.value);
		},
		updateFile(event) {
			this.medical = event.target.files[0];
		},
		edit() {
			this.editable = true;
		},
		reset() {
			this.editable = false;
			this.firstname = this.$store.state.user.firstname;
			this.lastname = this.$store.state.user.lastname;
			this.email = this.$store.state.user.email;
			this.base = this.$store.state.user.base;
		},
		save(id) {
			this.editable = false;
			var data = new FormData();
			data.append("medical", this.medical);
			data.append("firstname", this.firstname);
			data.append("lastname", this.lastname);
			data.append("email", this.email);
			data.append("baseAirport", this.base.value);
			console.log(data);
			axios
				.put(process.env.VUE_APP_BACKEND_URL + "/auth/user/" + id, data, {
					headers: {
						Authorization: "bearer " + this.token,
						"Content-Type": "multipart/form-data",
					},
				})
				.then((response) => {
					this.setUser(response.data);
					console.log("Data was saved!");
				})
				.catch((e) => {
					console.log(e);
				});
		},
	},
};
</script>

<style></style>
